(function() {
  'use strict';

  angular.module('app').factory('POSService', POSService);

  POSService.$inject = ['$rootScope', 'API', 'NotifyService'];

  function POSService($rootScope, API, NotifyService) {
    var service = {},
        support_pos_priority = !!$rootScope.ENV.business.support_pos_priority;
    /**
     * This callback type is called `requestCallback` and is displayed as a global symbol.
     *
     * @callback requestCallback
     * @param {boolean} success
     * @param {Object} data
     */
    /**
     * @typedef MultiLanguageObject
     * @type {Object}
     * @property {string} en - String on English
     * @property {string} pl - String on Polish
     * @property {string} ru - String on Russian
     * @property {string} uk - String on Ukrainian
     */
    $rootScope.$on('user-logout', function() {
      $rootScope.POS = null;
    });

    /**
     * Get list of all POS
     */
    service.All = function(params, callback) {
      if (!params) {
        params = {};
      }
      if (support_pos_priority) {
        params.sort_by_priority = support_pos_priority;
      }

      API.get('/pos?{0}'.format(paramsToUrlQueryEncodeURIComponent(params)), function(success, data) {
        if (success) {
          $rootScope.POS = data;
        }
        callback(success, data);
      });
      // }
    };

    /**
     * Get list POS-es in loyalty
     */
    service.forLoyalty = function(id, callback) {
      API.get('/loyalty/' + id + '/pos', function(success, data) {
        if (success) {
          //
        }
        callback(success, data);
      });
    };

    /**
     * Get POS info
     */
    service.Get = function(id, callback) {
      API.get('/pos/' + id, function(success, data) {
        if (success) {
          updateItemInList($rootScope.POS, data);
        }
        callback(success, data);
      });
    };

    /**
     * Get POS References
     */
    service.GetReferences = function(id, callback) {
      API.get('/pos/' + id + '/references', function(success, data) {
        if (success) {

        }
        callback(success, data);
      });
    };
    /**
     * Change POS References
     */
    service.ChangeReferences = function(id, post_data, callback) {
      API.patch('/pos/' + id + '/references', post_data, function(success, data) {
        if (success) {
          updateItemInList($rootScope.POS, data);
          NotifyService.Success(data.message, false);
        }
        callback(success, data);
      });
    };
    /**
     * Create new POS
     */
    service.Create = function(post_data, callback) {
      API.post('/pos', post_data, function(success, data) {
        if (success) {
          NotifyService.Success(data.message, false);
        }
        callback(success, data);
      });
    };

    /**
     * Change POS info
     */
    service.Change = function(id, post_data, callback) {
      API.patch('/pos/' + id, post_data, function(success, data) {
        if (success) {
          updateItemInList($rootScope.POS, data);
          NotifyService.Success(data.message, false);
        }
        callback(success, data);
      });
    };

    /**
     * Upload photo
     *
     * @param {string} posID - POS ID
     * @param {object} data - photo data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UploadPhoto = function(posID, data, callback) {
      API.postImage('/pos/' + posID + '/photo', data, function(success, response) {
        callback(success, response);
      });
    };

    /**
     * Delete/Clear POS photo
     *
     * @param {string} posID - POS ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeletePhoto = function(posID, callback) {
      API.delete('/pos/' + posID + '/photo', null, function(success, response) {
        callback(success, response);
      });
    };

    /**
     * Return POS online store info
     *
     * @param {string} posID - POS ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetOnlineStore = function(posID, callback) {
      API.get('/pos/' + posID + '/online_store', function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Modify POS online store info
     *
     * @param {string} posID - POS ID
     * @param {object} post_data - POS online store data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UpdateOnlineStore = function(posID, post_data, callback) {
      API.patch('/pos/' + posID + '/online_store', post_data, function(success, data) {
        callback(success, data);
      });
    };

    return service;
  }

})();
